import { useCallback } from "react"

export function useGoogleAuth() {
  const googleSignIn = useCallback(async () => {
    window.location.href = `${process.env.GATSBY_GETFLOW_API_ENDPOINT}/auth/google?redirect_uri=${process.env.GATSBY_GETFLOW_API_ENDPOINT}/credentials/google/public`
  }, [])

  return {
    googleSignIn,
  }
}
